import React from "react";

/** Opens NGE quality in Research (parallel to MatchupLink for MLB games). */
const NGEQualityLink = ({ game }) => {
  const gamePk = game?.gamePk;
  const label = game?.name || "Unknown";
  if (gamePk == null) {
    return <>{label}</>;
  }
  return (
    <a
      href={`https://research.mlb.com/nge/${gamePk}/quality`}
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </a>
  );
};

export default NGEQualityLink;
